module.exports = __webpack_public_path__ + "static/media/feature_list4.b8700481.png";